module.exports = __webpack_public_path__ + "img/Poor Solder Joint.b8fb8c37.png";